<template>
        <!-- Modal -->
        <div class="modal fade" id="deleteUserModal" tabindex="-1" aria-labelledby="createuserModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                        <div class="modal-content">
                                <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Eliminar Usuario</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                        </button>
                                </div>
                                <div class="modal-body">
                                        <div v-if="state == 'form'">
                                                <p>¿Desea eliminar el usuario {{ user_name}}?.</p>
                                        </div>
                                    
                                        <div v-if="state == 'load'">
                                        <img :src="require('@/assets/images/system/Spinner.gif')" class="mx-auto d-block" width="150" height="150" border="0"> 
                                        </div>
                                        <div v-if="state == 'successfully'">
                                                <p>Usuario eliminado con éxito</p>
                                        </div>
                                </div>
                                <div class="modal-footer" v-if="state == 'form'">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                                        <button type="button" class="btn btn-success" @click="sendForm">Eliminar</button>
                                </div>
                                <div class="modal-footer" v-if="state == 'successfully'">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                                </div>
                        </div>
                </div>
        </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
        name: 'deleteUser',
        props:{
                user_id: String,
                user_name: String
        },
        data(){
                return {
                        name: '',
                        id: '',
                        state:'form'
                }
        },
        methods: {
                ...mapActions([
                                'deleteUser',
                        ]),
                async sendForm(){
                        const payload = {
                                id: this.id
                        }
                        this.state = "load"
                        let status = await this.deleteUser(payload) 
                        console.log(status.data)
                        if(status.data.status == 'ok'){
                                this.state = "successfully"
                                this.emitSuccessfullyState()
                        }
                },
                emitSuccessfullyState(){
                        this.$emit("deleted",this.id)
                }
        },
        updated(){
                this.name = this.user_name
                this.id = this.user_id
                this.state = "form"
        }
        }
</script>

<style>
</style>